import { render, staticRenderFns } from "./DynamicExcelReport.vue?vue&type=template&id=b1b8f0b8"
import script from "./DynamicExcelReport.vue?vue&type=script&lang=js"
export * from "./DynamicExcelReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports